<template>
	<div class="meeting-live">
		<div class="video">
			<div class="viewNumber" v-if="liveDetails.show_views">观看人数 : {{viewNum}}人</div>
			<player ref="player" :videoUrl="videoUrl" v-if="JSON.stringify(liveDetails)!='{}'"></player>
			<h3>{{liveDetails.name}}</h3>
		<div class="swiper-img">
			<van-swipe :autoplay="3000" indicator-color="white">
					<van-swipe-item v-for="(item,index) in swiperImg" :key="index" @click="clickSwiperImg(item)">
					  <img :src="item.banner_url" alt="">
					</van-swipe-item>
			</van-swipe>
		</div>
		</div>
		<div class="hr-7" ref="line"></div>
		<div class="container">
			<van-tabs v-model="active" animated swipeable color="#901d22" title-inactive-color="#999" title-active-color="#090909">
			  <van-tab  title="日程安排">
			    <schedule  ref="schedule" :meetingSchedule="meetingSchedule"></schedule>
			  </van-tab>
			  <van-tab  title="互动讨论">
			    <discuss ref="discuss" :admin="admin"></discuss>
			  </van-tab>
			  <van-tab  title="切换会场">
			   	<meeting-place :meetingsPlace="meetingsPlace"></meeting-place>
			  </van-tab>
			  <van-tab  title="会议介绍" v-if="is_show_des">
				  <introduction :meetingDes="meetingDes"></introduction>
			  </van-tab>
			</van-tabs>
		</div>
		<return></return>
		<van-popup v-model="showActivity" position="center" @close="closePop"  :close-on-click-overlay="closeOverlay" >
			<collect-info :fieldArr="fieldArr" @func="changeInfoStatus"></collect-info>
		</van-popup>
		<!-- 弹出二维码 -->
		<van-popup
		v-model="is_show_recommend_qrcode"
		closeable
		position="center"
		class="qrcode"
		:style="{ width: '280px',height:'280px'}"
		>
		<img :src="liveDetails.recommend_qrcode_url" alt="">
		</van-popup>
	</div>
</template>
<script>
	import Schedule from '../../components/Meeting/Schedule'
	import Discuss from '../../components/Meeting/Discuss'
	import MeetingPlace from '../../components/Meeting/MeetingPlace'
	import CollectInfo from '../../components/Meeting/CollectInfo'
	import Player  from '../../components/Meeting/Player'
	import Introduction from '@/components/Meeting/Introduction'
	import Return from '@/components/Meeting/Return'
	import {MeetingBanner,MeetingsCollectInfo,MeetingsPlace,MeetingsPlaceDetails,SessionsViewsNum,PersoanalUserInfo,Signature,MeetingChat,MeetingchatList,MeetinganonymousChat} from '../../config/interface.js'
	export default{
		components:{
			Schedule,
			Discuss,
			MeetingPlace,
			Player,
			Introduction,
			Return,
			CollectInfo
		},
		data(){
			return{
				closeOverlay:false,
				time:10*60*1000,
				admin:[],      //超级管理员
				floatWindow:true,    //浮窗
				showActivity:false,  //活动展示
				viewGift:true,       //观看直播得礼物
				active:0,
				viewNum:0,        //观看人数
				liveDetails:{},
				meetingsPlace:[],
				signatureInfo:{},
				userInfo:this.$store.state.userInfo,
				meetingSchedule:[],     //会议日程
				videoUrl:'',   //视频url
				fieldArr:[],    //字段
				swiperImg:[],
				is_show_recommend_qrcode:false,				//二维码展示
				is_show_des:false,				//显示会议介绍
				meetingDes:'',
				value:0,
				websock:'',
				obj:'',
				room_id:this.$route.query.id,      //房间号
				connectWebSocket:false,     //websocket是否连接
				pingTimer:null,             //定时器
				topicList:[],               //话题列表
				userId:0,
				last_id:0,
				isWX:false
			}
		},
		mounted(){
			let top=this.$refs.line.getBoundingClientRect().top;
			let bottom=this.$refs.line.getBoundingClientRect().bottom;
			this.id=this.$route.query.id;
			this.meeting_id=this.$route.query.meeting_id;
			this.getMeetingsPlaceDetails();
			this.getMeetingsPlace();
			this.getMeetingNumer();
			this.getBanner();
			// if(this.$route.query.token){
			// 	localStorage.setItem('token',this.$route.query.token);
			// }
			if(common.is_weixin()){
				this.getActivities();
			}else{
				//非微信浏览器环境  要请求游客评论
				// this.$nextTick(()=>{
				// 	this.$refs.discuss.getanonymousChat();
				// })
			}
			this.isWX=common.is_weixin()
				if(common.is_weixin()){
					this.getSignature();
				}else{
					this.getanonymousChat();
				}
				let keyTimer = null;
				document.body.addEventListener('focusin', () => {
					//软键盘弹起事件
					clearInterval(keyTimer);
				});
				document.body.addEventListener('focusout', () => {
				    // 软键盘关闭事件
					window.scrollTo(0, 0);
				    keyTimer = setTimeout(() => {
				      if (window.pageYOffset > 0) {
				        window.scrollTo(0, 0);
				      }
				    }, 200);
				})


		},
		methods:{
			//活动
			getActivities(){
				const url=MeetingsCollectInfo;
				const method='POST';
				let params={
					meeting_id:this.meeting_id
				};
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						if(data.length!=0){
							this.fieldArr=data.extend_columns;
							this.showActivity=Boolean(data.extend_columns.length);
						}else{
							this.$nextTick(()=>{

								this.$refs.discuss.getSignature();
							})
						}
					}
				})
			},
			closePop(){
				this.showActivity=false;
			},
			/**
			 * 去注册
			 */
			goRegister(){

				this.$router.push({
					path:'/user/register'
				})
			},
			//会场详情
			getMeetingsPlaceDetails(){
				this.$store.dispatch('isShowLoading',true);
				const url=MeetingsPlaceDetails;
				const method='POST'
				let params={
					session_id:this.id
				}
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.liveDetails=data.session;
						this.is_show_recommend_qrcode=this.liveDetails.is_show_recommend_qrcode?true:false;
						this.is_show_des=this.liveDetails.is_show_des;
						this.meetingDes=this.liveDetails.meeting.des;
						this.meetingSchedule=data.chapters;
						this.admin=data.session.admin;
						if(common.is_weixin()){
							common.wxShare(data.session.name,'',data.session.shareimg);
						}
						//子组件加载完成后 向子组件传递数据
						this.$nextTick(()=>{
							this.$refs.player.getLiveInfo(data.session)
						})
					}
					this.$store.dispatch('isShowLoading',false);
				})
			},
			//会议广告位
			getBanner(){
				const url=MeetingBanner;
				const method='POST'
				let params={
					session_id:this.id
				}
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.swiperImg=data;
					}
				
				})
			},
			changeInfoStatus(data){
		
				this.showActivity=data;
			},
			//会议会场
			getMeetingsPlace(){
				const url=MeetingsPlace;
				const method='POST';
				let params={
					meeting_id:this.meeting_id
				}
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.meetingsPlace=data;
					}
				})
			},
			//会议观看人数
			getMeetingNumer(){
				const url=SessionsViewsNum;
				let params={
					session_id:this.id};
				const method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.viewNum=data.views;
					}
				})
			},
			clickSwiperImg(item){
				window.location.href=item.url;
			},
			//得到签名
			getSignature(){
				if(Object.keys(this.signatureInfo).length==0){
					const url=Signature;
					const method='POST';
					let params={}
					fetch(url,params,method)
					.then((res)=>{
						if(res.code==0){
							let data=res.data;
							this.signatureInfo=data;
							if(!this.userInfo){
								this.getUserInfo();
							}else{
								this.initWebSocket();
								this.getLiveChat();
							}
										
						}
					})
					
				}else{
					if(!this.userInfo){
						this.getUserInfo();
					}
				}


			},
			//查看聊天记录
			getChatRecord(){
				if(common.is_weixin()){
					this.getLiveChat()
				}else{
					this.getanonymousChat();
				}
			},
			//查看匿名聊天记录
			getanonymousChat(){
				const url=MeetingchatList;
				let params={
					session_id:this.room_id,
					last_id:this.last_id
				}
				let method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data.data;
						if(data.length>0){
							data.forEach((item,index)=>{
								let obj={
									avatar:require('@/assets/images/default_user.png'),
									msg:item.uuid+': '+item.content,
									direction:'left',		
								}
								this.topicList.unshift(obj);
															
							})
							this.last_id==0?this.backBottom():'';
							this.last_id=data[data.length-1].id;
							
							
						}else{
							if(this.last_id!=0){
								common.toast('已经到顶了',1000);    //第一次为空时不弹出弹窗
								this.disabledPull=true;
							}
							
						}
						this.isEmpty=this.topicList.length>0?false:true;
						this.isLoading=false;
					}
				})
			},
			//查看实时聊天记录
			getLiveChat(){
				const url=MeetingChat;
				let params={
					session_id:this.room_id,
					last_id:this.last_id
				}
				const methos='POST';
				fetch(url,params,methos)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						if(data.length>0){
							data.forEach((item,index)=>{
								let obj={
									avatar:item.avatar,
									msg:`<i>${item.nickname} :</i> ${item.params.body}`,
									direction:this.userInfo.ecs_id==item.uasid?'right':'left',
									isAdmin:item.params.from_admin?'admin':''	
								}
								this.topicList.unshift(obj);
								console.log(obj);							
							})
							this.last_id==0?this.backBottom():'';
							this.last_id=data[data.length-1].id;
							
							
						}else{
							if(this.last_id!=0){
								common.toast('已经到顶了',1000);    //第一次为空时不弹出弹窗
								this.disabledPull=true;
							}
							
						}
						this.isEmpty=this.topicList.length>0?false:true;
						this.isLoading=false;
					}
				})
			},
			//初始化weosocket
			initWebSocket(){ 
			 	let platform=this.signatureInfo.platform;
			 	let timestamp=this.signatureInfo.timestamp;
			 	let uasid=this.signatureInfo.uasid;
			 	let signature=this.signatureInfo.signature;
			 	let nickname=this.userInfo.nickname;
			 	let avatar=this.userInfo.avatar;
        		const wsuri = "ws://ws.talkmed.com/xgzx-pro?platform="+platform+"&timestamp="+timestamp+"&uasid="+uasid+"&signature="+signature+"&nickname="+nickname+"&avatar="+avatar; 
        		this.websock = new WebSocket(wsuri);
        		this.websock.onopen =(data)=>{
        			console.log('连接成功')
        		};        
        		this.websock.onmessage = (event)=>{
        			this.websocketonmessage(event);
        		};               
        		this.websock.onerror = ()=>{
        			this.websocketonerror();
        		};       
        		this.websock.onclose =()=>{
        			this.websocketclose();
      			};
      		},
      		//数据发送
      		websocketSendMessage(){
      			let params={
      				"action": "send_to_all_room_member",
					"params": {
					    "raw": {
					      "body": this.content
					    }
					},
					"room_id":this.room_id
      			}
      			this.websock.send(JSON.stringify(params));
      			this.content='';
      			
      		},
		    //连接建立失败重连
	      	websocketonerror(){
	        	this.initWebSocket();
	      	},
	      	//数据接收
	      	websocketonmessage(res){ 
	      		if (res.data == "pong") return;
	        	var data = JSON.parse(res.data);
	        	//连接成功  加入房间
	        	if(data.code==201){
					this.joinRoom();
					this.connectWebSocket=true;
					this.keepSocket();    
				}else if(data.code==200){
					//正常响应
					console.log(data.action);
					let str=data.action;
					let userId=this.userInfo?this.userInfo.ecs_id:0;
					switch(str){
						//接收到群发信息
						case 'send_to_all_room_member':
						let receiveData=data.data.msg_list[0];
						let obj={
							avatar:receiveData.avatar,
							msg:`<i>${receiveData.nickname} :</i> ${receiveData.body}`,
							direction:userId==receiveData.from_id?'right':'left',
						}
						this.topicList.push(obj);
						this.backBottom();
						break;
						//消息正在审核中
						case 'wait_check_msg':
						common.toast(data.message,1500);
						break;
						
					}
				}else if(data.code == 301 || data.code == 403){
					//被迫下线  签名错误或者验证已过期
					this.getSignature();
			
				}
	      	},
	      	//关闭websocket
	      	websocketClose(){
	      		this.websock.close();
	      	},
	      	//加入房间
	      	joinRoom(){
	      		let nickname=this.userInfo.nickname;
			 	let avatar=this.userInfo.avatar;
	      		let obj={
	      			"type": "room",
	        		"action":"join_room",
	        		"params": {
	        			"nickname":nickname,
	        			"avatar":avatar
	        		},
	        		"room_id":this.room_id
	      		}
	      		this.websock.send(JSON.stringify(obj));
	      	},
		  	//  维持心跳  WebSocket Ping Pong
		    keepSocket(){
			      console.log("ping");
			      if (this.connectWebSocket) {
			    	  this.websock.send("ping");
			      }
			      this.pingTimer = setTimeout(()=> {
			        this.keepSocket();
			      }, 1000 * 30);
		  	},
		  	backBottom(){
		  		// let ele=this.$refs.mesContainer;
				//   let scrollTop=0;
				//   this.$nextTick(()=>{
				// 	 if(ele.scrollHeight>ele.clientHeight){
				// 		scrollTop=ele.scrollHeight-ele.clientHeight+44;
				// 		this.$refs.mesContainer.scrollTop=scrollTop;
				//   	}
				//   })
		  	},
	      	websocketclose(e){  
	        	console.log('断开连接',e);
			  },
			//发送匿名聊天
			sendanonymousChat(){
				const url=MeetinganonymousChat;
				let params={
					session_id:this.room_id,
					content:this.content
				}
				let code='';
				if(localStorage.getItem('uuid')){
					code=localStorage.getItem('uuid');

				}else{
					for(let i=0;i<=7;i++){
						let num=Math.floor(Math.random()*10);
						code+=num;
					}
					localStorage.setItem('uuid',code)
				}
				params.uuid=code;
				let method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let obj={
							avatar:require('@/assets/images/default_user.png'),
							msg:params.uuid+': '+this.content,
							direction:'left',		
						}
						this.topicList.push(obj);
						this.content='';
						
					}
				})
			},
			//发送讨论
			sendDiscuss(){
				if(common.is_weixin()){
					this.content!=''?this.websocketSendMessage():'';
				}else{
					this.content!=''?this.sendanonymousChat():'';
				}
				
			},
			//点赞
			giveLike(){
				this.content='[emo:1]'
				this.content!=''?this.websocketSendMessage():'';
			},
		},
		destroyed(){
		  window.removeEventListener('popstate', this.goBack, false);
		  //退出这个页面  录播url为空
		  this.$store.dispatch('receiveVideoUrl','');
		  //建立连接  才可以关闭
			if(this.connectWebSocket){
				clearTimeout(this.pingTimer);
			    this.websocketClose();
			}
		}
	}
</script>
<style lang="scss">
	.meeting-live{
		display: flex;
		flex-direction: column;
		height:100%;
		.video{
			.viewNumber{
				position: absolute;
				top:0;
				left:0;
				z-index:1000;
				width:100%;
				height:20px;
				line-height: 20px;
				text-align: center;
				font-size:12px;
				color:#fff;
				background:rgba(17,17,17,0.4);
			}
			h3{
				padding:6px 15px;
				font-size:15px;
				color:$color-black;
			}
		}
		.swiper-img{
			width:100%;
			img{
				width:100% !important;
			}
		}
		.container{
				width:100%;
				flex:1;
				display: flex;
				flex-direction: column;
				overflow: auto;
				.van-tab span{
					font-size:15px;
				}
				.van-tabs--line {
					height:100%;
				}
				.van-tabs__content{
					height:calc(100% - 45px);
				}
				.van-tab__pane-wrapper{
					overflow-y: auto;
				}
		}
		.van-popup{
			border-radius: 5px;
		}

		.return a{
			bottom:50px !important;
		}
		.activity{
				text-align: center;
				padding:25px 20px;
				background:linear-gradient(2deg,rgba(255,250,248,1) 0%,rgba(255,255,255,1) 100%);
				box-shadow:0px 5px 11px 0px rgba(0,0,0,0.14);
				border-radius:11px;
				.van-popup__close-icon--top-right{

					font-size:20px;
					color:#030303;
					top:10px;
					right:10px;
				}
				img{
					width:240px;
					margin:20px 0;
				}
				button{
					margin:0 auto;
					width:165px;
					height:40px;
					border:0px;
					background:linear-gradient(180deg,rgba(255,124,129,1) 0%,rgba(245,42,42,1) 100%);
					box-shadow:0px 5px 11px 0px rgba(0,0,0,0.14);
					border-radius:22px;
					// font-size:16px;
					// color:#fff;
					text-shadow:0px 5px 11px rgba(0,0,0,0.14);
					p{
						display:flex;
						color:#fff;
					}
				}
				>p{
					width:90%;
					margin:25px auto;
					text-align: justify;
				}
		}
		.qrcode{
			img{
				position: absolute;
				top:50%;
				left:50%;
				transform: translate(-50%,-50%);
				width:200px;
				height:200px;

			}
		}
		.meeting_des {
        	width:100%;
			padding:10px;
			box-sizing: border-box;
			img{
				display: block;
				width:100%  !important;
			}
    	} 
		// 领取礼物
		.receiveGifts{
			@include flex(row);
			align-items:center;
			position: fixed;
			right:0px;
			bottom:60px;
			width:82px;
			height:44px;
			background:rgba(244,103,45,1);
			box-shadow:0px 4px 10px 0px rgba(53,19,18,0.27);
			border-radius:100px 0px 0px 100px;
			img{
				width:60px;
				position: absolute;
				left:-12px;

			}
			p{
				margin-left:45px;
				font-size:11px;
				color:#fff;
				text-align: center;
				text-shadow:0px 1px 1px rgba(152,54,10,0.46)

			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/pages/Meeting/live.vue